import { useLocation } from 'react-router-dom';

const PRODUCTS = [
  {
    path: '/term-life',
    label: 'Term Life',
    icon: 'ri-shield-check-line',
    short: 'From $14/mo',
  },
  {
    path: '/whole-life',
    label: 'Whole Life',
    icon: 'ri-infinity-line',
    short: 'Lifetime coverage',
  },
  {
    path: '/mortgage-protection',
    label: 'Mortgage Protection',
    icon: 'ri-home-heart-line',
    short: 'From $14/mo',
  },
  {
    path: '/final-expense',
    label: 'Final Expense',
    icon: 'ri-user-heart-line',
    short: 'No exam required',
  },
  {
    path: '/annuities',
    label: 'Annuities',
    icon: 'ri-funds-box-line',
    short: 'Guaranteed income',
  },
];

export default function ProductNav() {
  const { pathname } = useLocation();

  return (
    <nav className="bg-[#F4F1EC] border-b border-[#E2DDD6]">
      <div className="max-w-[1100px] mx-auto px-6">
        <div className="flex items-center gap-1 overflow-x-auto scrollbar-hide py-0">
          {PRODUCTS.map((p) => {
            const active = pathname === p.path;
            return (
              <a
                key={p.path}
                href={p.path}
                className={`flex items-center gap-2 px-4 py-3 whitespace-nowrap text-[13px] font-semibold border-b-2 transition-all cursor-pointer flex-shrink-0 ${
                  active
                    ? 'border-[#D97642] text-[#D97642]'
                    : 'border-transparent text-[#4A5568] hover:text-[#1A3A52] hover:border-[#1A3A52]/30'
                }`}
              >
                <div className="w-4 h-4 flex items-center justify-center">
                  <i className={`${p.icon} text-[15px]`}></i>
                </div>
                <span>{p.label}</span>
                {active && (
                  <span className="hidden sm:inline text-[11px] font-normal text-[#D97642]/80 ml-1">
                    — {p.short}
                  </span>
                )}
              </a>
            );
          })}
        </div>
      </div>
    </nav>
  );
}
